// Chart color palette configuration matching badge component
// Each color has light (300) and medium (500) shades for background and border
// These colors can be used for lab member assignment in the future

export const CHART_COLORS = [
  {
    name: 'Red',
    value: 'red',
    bg: 'rgb(252, 165, 165)',    // red-300
    border: 'rgb(239, 68, 68)'    // red-500
  },
  {
    name: 'Yellow',
    value: 'yellow',
    bg: 'rgb(253, 224, 71)',     // yellow-300
    border: 'rgb(234, 179, 8)'    // yellow-500
  },
  {
    name: 'Green',
    value: 'green',
    bg: 'rgb(134, 239, 172)',    // green-300
    border: 'rgb(34, 197, 94)'    // green-500
  },
  {
    name: 'Blue',
    value: 'blue',
    bg: 'rgb(147, 197, 253)',    // blue-300
    border: 'rgb(59, 130, 246)'   // blue-500
  },
  {
    name: 'Purple',
    value: 'purple',
    bg: 'rgb(216, 180, 254)',    // purple-300
    border: 'rgb(168, 85, 247)'   // purple-500
  },
  {
    name: 'Pink',
    value: 'pink',
    bg: 'rgb(249, 168, 212)',    // pink-300
    border: 'rgb(236, 72, 153)'   // pink-500
  },
  {
    name: 'Slate',
    value: 'slate',
    bg: 'rgb(203, 213, 225)',    // slate-300
    border: 'rgb(100, 116, 139)'  // slate-500
  }
]

// Helper function to get color by name
export function getColorByName(name) {
  return CHART_COLORS.find(color => color.value === name.toLowerCase())
}

// Helper function to get color by index (with cycling)
export function getColorByIndex(index) {
  return CHART_COLORS[index % CHART_COLORS.length]
}

// Export for use in Rails via JSON
export function getColorsForDropdown() {
  return CHART_COLORS.map(color => ({
    label: color.name,
    value: color.value
  }))
}
